module.exports = __webpack_public_path__ + "static/media/GUIDE_0069_02.c744ace5.jpg";